import { HttpClient, HttpParams } from "@angular/common/http";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfileModel } from "src/app/models/Profile.model";
import { UserProfileModel } from "src/app/models/user-profile.model";
import { UserModel } from "src/app/models/user.modetl";
import { v_userprofile } from "src/app/models/v_userprofile.model";
import { FieldDescriptor, SpecialFormGroup } from "src/app/shared/util/SpecialForms";
import Swal from "sweetalert2";

@Component({
    selector: "app-user",
    templateUrl: "./user.component.html",
    styleUrls: ["../../../assets/css/style.scss"],
})
/** User component*/
export class UserComponent implements OnInit {
    /** User ctor */
    constructor(public http: HttpClient, private SpinnerService: NgxSpinnerService, private _builder: FormBuilder,private cdRef:ChangeDetectorRef) {

    }

    public v_userProfile: v_userprofile[];

    FormAddUser: FormGroup;
    FormAddUserProfile: FormGroup;
    submitted = false;
    submittedAddUserProfile=false;
    //DeleteUserProfile: UserProfileModel;
    public Users: UserModel[];
    public NewUser: UserModel = new UserModel();
    public UpdateUser: UserModel = new UserModel();
    
    //  public NewUser: UserModel = new UserModel();
    //  public UpdateUser: UserModel = new UserModel();
     public user = JSON.parse(localStorage.getItem("ResponseData"));
     public formUser: SpecialFormGroup;
     public formUserFields: FieldDescriptor[] = [];
     public Profiles: ProfileModel[];
     public IdProfilesObject: any[] = [];
     public NewUserProfile: UserProfileModel = new UserProfileModel();
     public UpdateUserProfile: UserProfileModel = new UserProfileModel();
     DeleteUserProfile: UserProfileModel;
     public formUserProfile: SpecialFormGroup;
     public formUserProfileFields: FieldDescriptor[] = [];

     
    public Iata: any[] = [];
    public EstadoSolicitud: any[] = [];
    public NombreCompleto: any[] = [];
    public IdentificacionTercero: any[] = [];
    public NombreTercero: any[] = [];
    public AreaNegocio: any[] = [];
    public Cargo: any[] = [];
    public Email: any[] = [];
    public Aprobador: any[] = [];
    public Perfil: any[] = [];
    displayModal: boolean;
    displayModalEdit : boolean;
    displayModalProfile:boolean;
    displayModalProfileEdit:boolean;
    isRepeatedMailBool:boolean;

    ngOnInit(): void {
        this.getAll();
        this.FormAddUserProfile = this._builder.group({
            IdUsuario: ['', [Validators.required, Validators.maxLength(50)]],
            IdPerfil: ['', [Validators.required, Validators.maxLength(100)]],                      
          });
      
          this.FormAddUser = this._builder.group({
            NombreCompleto: ['', [Validators.required, Validators.maxLength(50)]],
            Email: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
            IdentificacionTercero: ['', [Validators.required, Validators.maxLength(30)]],
            AreaNegocio: ['', [Validators.required, Validators.maxLength(20)]],
            Cargo: ['', [Validators.required, Validators.maxLength(20)]],
            NombreTercero: ['', [Validators.required, Validators.maxLength(50)]],
            Iata: ['', [Validators.required, Validators.maxLength(50)]]           
          });
    }

   
  get formAddUser() {
    return this.FormAddUser.controls;
  }
  get formAddUserProfile() {
    return this.FormAddUserProfile.controls;
  }

    private getAll() {
        this.SpinnerService.show();
        let UserInf: any;
        UserInf = localStorage.getItem("ResponseData");
        let body = new HttpParams();
        body = body.set("data", UserInf);
        this.http.post<v_userprofile[]>(window.location.origin + "/api/User/GetUsers/", body).subscribe((data) => {
            this.v_userProfile = data;            
            console.log("-------Users------");
            console.log(this.v_userProfile);
            let iata = {};
            this.Iata = [];
            let stadosolicitud = {};
            this.EstadoSolicitud = [];
            let nombrecompleto = {};
            this.NombreCompleto = [];
            let idtercero = {};
            this.IdentificacionTercero = [];
            let ntercero = {};
            this.NombreTercero = [];
            let areanegocio = {};
            this.AreaNegocio = [];
            let cargo = {};
            this.Cargo = [];
            let email = {};
            this.Email = [];
            let aprobador = {};
            this.Aprobador = [];
            let perfil ={};
            this.Perfil=[];
            for (let index = 0; index < this.v_userProfile.length; index++) {
                iata = { label: this.v_userProfile[index].Usuario.Iata, value: this.v_userProfile[index].Usuario.Iata };
                nombrecompleto = { label: this.v_userProfile[index].Usuario.NombreCompleto, value: this.v_userProfile[index].Usuario.NombreCompleto };
                idtercero = { label: this.v_userProfile[index].Usuario.IdentificacionTercero, value: this.v_userProfile[index].Usuario.IdentificacionTercero };
                ntercero = { label: this.v_userProfile[index].Usuario.NombreTercero, value: this.v_userProfile[index].Usuario.NombreTercero };
                areanegocio = { label: this.v_userProfile[index].Usuario.AreaNegocio, value: this.v_userProfile[index].Usuario.AreaNegocio };
                cargo = { label: this.v_userProfile[index].Usuario.Cargo, value: this.v_userProfile[index].Usuario.Cargo };
                email = { label: this.v_userProfile[index].Usuario.Email, value: this.v_userProfile[index].Usuario.Email };
                aprobador = { label: this.v_userProfile[index].Usuario.Aprobador, value: this.v_userProfile[index].Usuario.Aprobador };
                perfil = { label: this.v_userProfile[index].Perfil.Nombre, value: this.v_userProfile[index].Perfil.Nombre };

                if (this.Iata.find((x) => x.label === this.v_userProfile[index].Usuario.Iata) == null) {
                    this.Iata.push(iata);
                    this.Iata.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                //Validaciones de los estados
                if(this.v_userProfile[index].Usuario.EstadoSolicitud === 2){
                    stadosolicitud = { label:"En Espera", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if(this.v_userProfile[index].Usuario.EstadoSolicitud === 3){
                    stadosolicitud = { label:"Aprobado", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if(this.v_userProfile[index].Usuario.EstadoSolicitud === 4){
                    stadosolicitud = { label:"No Aprobado", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }
                if(this.v_userProfile[index].Usuario.EstadoSolicitud === 5){
                    stadosolicitud = { label:"Dado de Baja", value: this.v_userProfile[index].Usuario.EstadoSolicitud };
                }                

                if (this.EstadoSolicitud.find((x) => x.value === this.v_userProfile[index].Usuario.EstadoSolicitud) == null) {
                    this.EstadoSolicitud.push(stadosolicitud);
                    this.EstadoSolicitud.sort((a, b) => { if (a.value < b.value) { return -1; } if (a.value > b.value) { return 1; } return 0; });
                }

                if (this.NombreCompleto.find((x) => x.label === this.v_userProfile[index].Usuario.NombreCompleto) == null) {
                    this.NombreCompleto.push(nombrecompleto);
                    this.NombreCompleto.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.IdentificacionTercero.find((x) => x.label === this.v_userProfile[index].Usuario.IdentificacionTercero) == null) {
                    this.IdentificacionTercero.push(idtercero);
                    this.IdentificacionTercero.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.NombreTercero.find((x) => x.label === this.v_userProfile[index].Usuario.NombreTercero) == null) {
                    this.NombreTercero.push(ntercero);
                    this.NombreTercero.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.AreaNegocio.find((x) => x.label === this.v_userProfile[index].Usuario.AreaNegocio) == null) {
                    this.AreaNegocio.push(areanegocio);
                    this.AreaNegocio.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Cargo.find((x) => x.label === this.v_userProfile[index].Usuario.AreaNegocio) == null) {
                    this.Cargo.push(areanegocio);
                    this.Cargo.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Email.find((x) => x.label === this.v_userProfile[index].Usuario.Email) == null) {
                    this.Email.push(email);
                    this.Email.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Aprobador.find((x) => x.label === this.v_userProfile[index].Usuario.Aprobador) == null) {
                    this.Aprobador.push(aprobador);
                    this.Aprobador.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }
                if (this.Perfil.find((x) => x.label === this.v_userProfile[index].Perfil.Nombre) == null) {
                    this.Perfil.push(perfil);
                    this.Perfil.sort((a, b) => { if (a.label < b.label) { return -1; } if (a.label > b.label) { return 1; } return 0; });
                }

            }
            this.SpinnerService.hide();
        });
        this.http.post<ProfileModel[]>(window.location.origin + "/api/Profile/GetPerfiles",body).subscribe((res) => {
            // Success
            this.Profiles = res;
    
            //Llenando arreglo para Select de Bases
            var Profile = {};
            this.IdProfilesObject = [];
            for (let index = 0; index < this.Profiles.length; index++) {
              Profile = {
                Id: this.Profiles[index].Id,
                Nombre: this.Profiles[index].Nombre,
                Is_Default : this.Profiles[index].IsDefault
              };
    
              this.IdProfilesObject.push(Profile);
            }
    
            //this.SetInitValidation();
    
            this.SpinnerService.hide();
          });
        
    }
    public UpdateUserProfiles(data: UserProfileModel) {
      //Spinner de Carga
      this.SpinnerService.show();      
      var user = JSON.parse(localStorage.getItem("ResponseData"))  
      //Seteando data de Auditoria
      data.ModificadoPor = user.Email;
      data.FechaModificado = new Date();      
      // Construyendo body de la peticion
      var request = JSON.stringify(data);
      let body = new HttpParams();
      body = body.set("data", request);
      const bodyUserProfile = {
        ObjectRequest: request,
      };
  
      /**** TODO: Validacion de Formulario antes de Enviar peticion  ****/
  
      this.http
        .post(
          window.location.origin + "/api/UserProfile/UpdateUserProfile",
          bodyUserProfile
        )
        .toPromise()
        .then((res) => {
          // Success
  
          this.hideModalDialogProfileEdit();
          this.SpinnerService.hide();
          this.cdRef.detectChanges();
          this.getAll();
          Swal.fire({
            //position: 'top-end',
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((err) => {
          // error
          console.error(err);
          this.SpinnerService.hide();
        });
    }
  
    public DeleteUserProfiles(data: v_userprofile) {
      debugger;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.DeleteUserProfile = new UserProfileModel();
          this.DeleteUserProfile.IdPerfil= data.Perfil.Id.toString();
          this.DeleteUserProfile.IdUsuario= data.Usuario.Id.toString();   
  
          this.SpinnerService.show();
          var request = JSON.stringify(this.DeleteUserProfile);
          let body = new HttpParams();
          body = body.set("data", request);
          const bodyUserProfile = {
            ObjectRequest: request,
          };
          this.http
            .post(
              window.location.origin + "/api/UserProfile/DeleteUserProfile",
              bodyUserProfile
            )
            .toPromise()
            .then((res) => {
              // Success
              var respuesta: any;
              respuesta = res;
              console.log(res);
              if (respuesta.Head.StackError) {
                this.SpinnerService.hide();
                Swal.fire(
                  "Error!",
                  "Something went wrong!. There is a relationship with UserProfile-UserProfile",
                  "error"
                );
              } else {
                this.SpinnerService.hide();
                this.getAll();
                Swal.fire(
                  "Deleted!",
                  "The UserProfile has been deleted.",
                  "success"
                );
              }
            })
            .catch((err) => {
              // error
              console.error(err);
              this.SpinnerService.hide();
            });
        }
      });
    }
    setSelect(element, input, data) {
      //Tratamiento del element antes de insertar en input
      var elem = element.target.value;
  
      if (input == "IdPerfil") {
        if (data == "UpdateUserProfile") {
          this.UpdateUserProfile.IdPerfil = elem;
        } else {
          this.UpdateUserProfile.IdPerfil = elem;
        }
      }
    }
    public CreateUser(data: UserModel) {
        //this.formUser.specialSet(data);
        //Spinner de Carga
        this.SpinnerService.show();
        
        if (this.FormAddUser.invalid) {
          this.SpinnerService.hide();
          return;
        }
    
        //Seteando data de Auditoria
        data.Id = 0;
        var user = JSON.parse(localStorage.getItem("Claims"))
        data.CreadoPor = user.email;
        data.EstadoSolicitud = 2;
        data.FechaCreacion = new Date();
    
        // Construyendo body de la peticion
        var request = JSON.stringify(data);
        let body = new HttpParams();
        body = body.set("data", request);
        const bodyUser = {
          ObjectRequest: request,
        };
        this.http.post(window.location.origin + "/api/User/CreateUser", bodyUser).toPromise().then((res) => {
           
            if (res == null) {              
            this.hideModalDialog();
            this.SpinnerService.hide();
            this.cdRef.detectChanges();
            this.getAll();
            Swal.fire({
              //position: 'top-end',
              icon: "error",
              title: "Failed to save user",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
                      
            this.user = res;
            if (this.user.UsuarioPerfils.length == "0") {
              this.CreateUserProfile(this.user.Id);
            }
            this.hideModalDialog();
            this.SpinnerService.hide();
            this.cdRef.detectChanges();
            this.getAll();
            Swal.fire({
              //position: 'top-end',
              icon: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
          .catch((err) => {
            // error
            console.error(err);
            this.SpinnerService.hide();
          });
        
      }

      public CreateUserProfile(id: string) {
        //Spinner de Carga
        debugger;
        this.SpinnerService.show();
        var data: UserProfileModel = new UserProfileModel();
        var user = JSON.parse(localStorage.getItem("Claims"))            
        //Seteando data de Auditoria
        data.Id = 0;
        data.IdUsuario = id;
        //profile default 2        
        data.IdPerfil = this.Profiles.filter(x => x.IsDefault == true)[0].Id.toString();
        data.CreadoPor = user.email;
        data.FechaCreacion = new Date();
    
        // Construyendo body de la peticion
        var request = JSON.stringify(data);
        let body = new HttpParams();
        body = body.set("data", request);
        const bodyUserProfile = {
          ObjectRequest: request,
        };
    
        /**** Validacion de Formulario antes de Enviar peticion  ****/
    
        this.http
          .post(
            window.location.origin + "/api/UserProfile/CreateUserProfile",
            bodyUserProfile
          )
          .toPromise()
          .then((res) => {
            // Success
            console.log(res);
    
            if (res != null) {
              
              this.ngOnInit();
              this.SpinnerService.hide();
              Swal.fire({
                //position: 'top-end',
                icon: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              
              this.ngOnInit();
              this.SpinnerService.hide();
              Swal.fire({
                //position: 'top-end',
                icon: "warning",
                title: "Error, Your work hasn't been saved",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            // error
            console.error(err);
            this.SpinnerService.hide();
          });
      }

      public GetIdUserProfile(data: v_userprofile) {
        debugger;
        this.UpdateUserProfile = new UserProfileModel();
        this.UpdateUserProfile.IdPerfil = data.Perfil.Id.toString();
        this.UpdateUserProfile.IdUsuario = data.Usuario.Id.toString();
        
        this.SpinnerService.show();
        var request = JSON.stringify(this.UpdateUserProfile);
        let body = new HttpParams();
        body = body.set("ObjectRequest", request);
        const bodyUserProfile = {
          ObjectRequest: request,
        };
        this.http
          .post<UserProfileModel>(
            window.location.origin + "/api/UserProfile/GetIdUserProfile",
            bodyUserProfile
          )
          .toPromise()
          .then((res) => {         
            debugger;
            //Objeto para actualizar
            this.UpdateUserProfile = res;
            
            this.showModalDialogEditProfile();
            //Servicio de Loader-Spinner
            this.SpinnerService.hide();
            //this.getAll();
          })
          .catch((err) => {
            // error
            console.error(err);
            this.SpinnerService.hide();
          });
      }
      
  public UpdateUsers(data: UserModel) {
    debugger;
    if (this.formAddUser.invalid) {
      return;
    }
    //Spinner de Carga
    this.SpinnerService.show();
    var user = JSON.parse(localStorage.getItem("ResponseData"))   
    //Seteando data de Auditoria
    data.ModificadoPor = user.Email;
    data.FechaModificado = new Date();

    // Construyendo body de la peticion
    var request = JSON.stringify(data);
    let body = new HttpParams();
    body = body.set("data", request);
    const bodyUser = {
      ObjectRequest: request,
    };

    
    /**** TODO: Validacion de Formulario antes de Enviar peticion  ****/

    this.http
      .post(window.location.origin + "/api/User/UpdateUser", bodyUser)
      .toPromise()
      .then((res) => {
        // Success

        console.log(res);
        this.getAll()
        this.hideModalDialogEdit();
        this.cdRef.detectChanges();
        this.SpinnerService.hide();
        Swal.fire({
          //position: 'top-end',
          icon: "success",
          title: "Your work has been saved",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((err) => {
        // error
        console.error(err);
        this.SpinnerService.hide();
      });
  }

      
  public GetIdUser(data: UserModel) {
    this.UpdateUser = new UserModel();
    this.SpinnerService.show();
    var request = JSON.stringify(data);
    let body = new HttpParams();
    body = body.set("ObjectRequest", request);
    const bodyUser = {
      ObjectRequest: request,
    };
    this.http.post<UserModel>(window.location.origin + "/api/User/GetIdUser", bodyUser)
      .toPromise().then((res) => {   
        //Objeto para actualizar
        this.UpdateUser = res;
        this.cdRef.detectChanges();
        //Servicio de Loader-Spinner
        this.SpinnerService.hide();
        //this.getAll();
        
      })
      .catch((err) => {
        // error
        console.error(err);
        this.SpinnerService.hide();
      });
  }
  public validateMail()
  {
      
    const nameVerify = this.NewUser.Email!= undefined?(this.NewUser.Email as string).trim().toLowerCase():'';
    const nameList = this.v_userProfile.filter(i => i.Usuario.Email!=null).map( i => i.Usuario.Email.toLowerCase());
    const result = nameList.includes(nameVerify);
    
    if (result) {
      this.isRepeatedMailBool = true
    }
    else
    {
      this.isRepeatedMailBool = false
    }
  }
    

    showModalDialogAdd() {
        this.onReset();
        this.displayModal = true;
      }
      showModalDialogEdit(){
        this.onReset();
        this.displayModalEdit = true;
      }
      showModalDialogEditProfile(){
        //this.onResetAddProfile();
        //this. this.UpdateUserProfile.IdProfile
        this.displayModalProfileEdit = true;
      }
      showModalDialogAddProfile(User: UserModel){
        this.onResetAddProfile();
        this.NewUserProfile.IdUsuario= User.Id.toString();
        this.displayModalProfile = true;
      }
      onResetAddProfile() {
        this.submittedAddUserProfile = false;
        this.FormAddUserProfile.reset();
      }
      onReset() {
        this.submitted = false;
        this.FormAddUser.reset();
      }
      hideModalDialog(){
        this.onReset();
        this.displayModal = false;
      }
      hideModalDialogEdit(){
        this.onReset();
        this.displayModalEdit = false;
      }
      hideModalDialogProfile(){
        this.onResetAddProfile();
        this.displayModalProfile = false;
      }
      hideModalDialogProfileEdit(){
        this.onResetAddProfile();
        this.displayModalProfileEdit = false;  
      }
}
